(function () {
  'use strict';

  /* @ngdoc object
   * @name flightPaxCountReport
   * @description
   *
   */
  angular
    .module('flightPaxCountReport', [
      'ui.router'
    ]);
}());
